import { fadeIn } from '../../../utils/utils';
import './blockDropdown.scss';

export default class blockDrop {
    constructor(blockDrop) {
        this.$tab = blockDrop;
        this.$tabName = this.$tab.querySelectorAll('.js-blockDrop-name');
        this.$tabItem = this.$tab.querySelectorAll('.js-blockDrop-item');

        this.init();
    }

    init() {
        this.$tabName.forEach((name, index) => {

            name.setAttribute('data-tab-index', `${index}`);
            name.addEventListener('click', this.changeTab.bind(this));
        });
        this.openTabItem(0);
    }

    changeTab(e) {
        const targetTab = e.target.closest('.js-blockDrop-name');
        const blockNumber = targetTab.getAttribute('data-tab-index');
        let clicked;
		clicked = targetTab.classList.contains('active');

        this.$tabName.forEach((name) => {
				name.classList.remove('active');
				name.innerHTML = '<p>Подробнее</p> <svg class="button-svg" width="25" height="28"><use href="/newFront/dist/assets/sprite.svg#dropdown-arrow"></use></svg>'
			});

		if (clicked !== true) {
			targetTab.innerHTML  = '<p>Свернуть</p> <svg class="button-svg" width="25" height="28"><use href="/newFront/dist/assets/sprite.svg#dropdown-arrow"></use></svg>'
			targetTab.classList.add('active');
			this.openTabItem(blockNumber);
		} else {
			this.closeTabItem(blockNumber);
		}


    }

	closeTabItem(blockNumber) {
		this.$tabItem.forEach((item) => {

			item.style.display = 'none';
		});

	}

    openTabItem(blockNumber) {
        this.$tabItem.forEach((item) => {
            // item.classList.remove('active');
            item.style.display = 'none';
        });
        fadeIn(this.$tabItem[blockNumber], 500);
        // this.$tabItem[blockNumber].classList.add('active');
    }

}
